export default "__VITE_ASSET__B5KeH8Iu__"